import { styled } from '@mui/material';
import { Box } from '@mui/system';

import { labelColor } from '@/src/styles/theme/lightThemeOptions';

export const FooterBox = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    right: '0px',
    width: '100%',
    alignItems: 'center',
    padding: '6px 0 10px',
    '& :last-child': {
        paddingLeft: '1px',
    },
    '@media(max-width: 1024px)': {
        marginBottom: '60px',
        ul: {
            paddingInlineStart: '0px',
        },
    },
    '& .footer': {
        display: 'flex',
    },
    '& .footer_logo': {
        width: 'auto',
        height: 'auto',
    },
    '@media(max-width: 767px)': {
        flexDirection: 'column',
        '& .footer_logo': {
            order: -1, // Show logo first on mobile
        },
        '& .desktop_only': {
            display: 'none',
        },
    },
});

export const FooterItems = styled('li')(({ theme }) => ({
    fontWeight: '400',
    fontSize: theme.spacing(2.75),
    lineHeight: '14px',
    color: labelColor,
    padding: theme.spacing(0, 2, 0, 0),
    margin: theme.spacing(0, 2, 0, 0),
    listStylePosition: 'inside',
    '&:first-of-type': {
        listStyleType: 'none',
    },
    '&:last-child': {
        paddingLeft: 0,
        paddingRight: 0,
        margin: theme.spacing(0),
    },
    '@media(max-width: 1024px)': {
        fontSize: theme.spacing(2.46),
    },
    '@media(max-width: 767px)': {
        fontSize: theme.spacing(2.15),
    },
}));
